<template>
    <div>
        <MAModal
            v-if="store__showDeleteModal"
            title="Delete Dataset"
            class="delete-data-modal"
            @close="store__toggleDeleteModal()"
        >
            <!-- Description Step -->
            <div
                slot="content"
                class="data-uploader-modal"
            >
                <MASpinner v-if="store__isLoading" />
                <div class="slds-grid slds-p-around_small">
                    Are you sure you want to delete {{ store__datasetToEdit.datasetLabel }}?
                </div>
            </div>
            <!-- End Description Step -->

            <!-- Description Step Footer-->
            <div
                slot="footer"
                class="slds-grid slds-grid_align-end"
            >
                <button
                    class="slds-button slds-button_neutral"
                    :disabled="store__lockButtons"
                    @click="store__toggleDeleteModal()"
                >
                    Cancel
                </button>
                <button
                    class="slds-button slds-button_brand"
                    :disabled="store__lockButtons"
                    @click="deleteDataSet()"
                >
                    Confirm
                </button>
            </div>
            <!-- End Description Step Footer-->
        </MAModal>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

import MAModal from '@mapanything/ma-lib/src/vue/components/MAModal.vue';
import MASpinner from '@mapanything/ma-lib/src/vue/components/MASpinner.vue';

export default {
    name: 'Dashboard',
    components: {
        MAModal,
        MASpinner
    },
    computed: {
        ...mapState({
            store__loginState: 'loginState',
            store__isLoading: 'isLoading',
            store__lockButtons: 'lockButtons',
            store__datasetToEdit: 'datasetToEdit',
            store__showDeleteModal: 'showDeleteModal'
        })
    },
    methods: {
        ...mapMutations({
            store__toggleSpinner: 'toggleSpinner',
            store__toggleLockButtons: 'toggleLockButtons',
            store__toggleDeleteModal: 'toggleDeleteModal'
        }),
        /* Deletes custom dataset completely */
        deleteDataSet() {
            return new Promise((resolve, reject) => {
                const API_URL = document.location.href;

                const options = {
                    params: {
                        datasetID: this.store__datasetToEdit.datasetID
                    }
                };

                // Begin loading spinner...
                this.store__toggleSpinner();
                // Lock buttons...
                this.store__toggleLockButtons();

                this.$http.delete(`${API_URL}api/dataset`, options)
                .then((res) => {
                    if (res.status === 200) {
                        const toastMessage = {
                            showCloseButton: true,
                            type: 'success',
                            title: 'Success',
                            body: `Dataset "${this.store__datasetToEdit.datasetLabel}" deleted`,
                            timeout: 5000
                        };

                        this.$vueOnToast.pop(toastMessage);

                        resolve(res);
                    } else {
                        const toastMessage = {
                            showCloseButton: true,
                            type: 'error',
                            title: 'Server Error',
                            body: `There was an issue deleting dataset "${this.store__datasetToEdit.datasetLabel}"`,
                            timeout: 5000
                        };

                        this.$vueOnToast.pop(toastMessage);

                        reject(res);
                    }
                })
                .catch((err) => {
                    console.log('err', err);
                    const toastMessage = {
                        showCloseButton: true,
                        type: 'error',
                        title: 'Server Error',
                        body: `There was an issue contacting the server to delete dataset "${this.store__datasetToEdit.datasetLabel}"`,
                        timeout: 5000
                    };

                    this.$vueOnToast.pop(toastMessage);

                    reject(err);
                })
                .finally(() => {
                    // End loading spinner...
                    this.store__toggleSpinner();
                    // Unlock buttons...
                    this.store__toggleLockButtons();
                    // Hide Modal...
                    this.store__toggleDeleteModal();
                });
            });
        }
    }
};
</script>

<style lang="scss" scoped>
    .delete-data-modal /deep/ .slds-modal__container {
        width: 25%;

        .slds-modal__close {
            display: none;
        }
    }

    .slds-pill__icon_container .slds-icon {
        display: flex;
        justify-content: center;
    }

    .slds-setup-assistant__item {
        border-bottom: none;
    }

    .dashboard-modal {
        min-height: 70%;
    }
</style>
